/**
 * Merge intervals: https://javascript.plainenglish.io/javascript-algorithms-merge-intervals-leetcode-98da240805bc
 */
export const mergeIntervals = (intervals: number[][]): number[][] => {
  const sortedIntervals: number[][] = intervals.sort((a, b) => a[0] - b[0])
  const mergedIntervals: number[][] = []

  for (let i = 0; i < intervals.length; i++) {
    if (
      !mergedIntervals.length ||
      mergedIntervals[mergedIntervals.length - 1][1] < sortedIntervals[i][0]
    ) {
      mergedIntervals.push(sortedIntervals[i])
    } else {
      mergedIntervals[mergedIntervals.length - 1][1] = Math.max(
        mergedIntervals[mergedIntervals.length - 1][1],
        sortedIntervals[i][1]
      )
    }
  }
  return mergedIntervals
}
